import { urlGlobal2 } from './GlobalService';

const EXCLUDED_PLAN_IDS = [1, 4, 5, 6, 7, 9, 10, 11, 12, 14, 16, 20, 21, 23, 25, 26, 27, 29, 31];

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    token
  };
};

export const getAuthUserBot = async () => {
  try {
    const resp = await fetch(`${urlGlobal2}/auth/verificarToken`, {
      method: 'GET',
      headers: getHeaders()
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const getEventosInstalador = async ({ desde, hasta, empleadoId }) => {
  try {
    const url = new URL(`${urlGlobal2}/eventos`);
    const params = { desde, hasta };
    if (empleadoId) {
      params.empleadoId = `${empleadoId}`;
    }
    url.search = new URLSearchParams(params).toString();

    const resp = await fetch(url, {
      method: 'GET',
      headers: getHeaders()
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const getMisEquiposByEmpleado = async (empleadoId) => {
  try {
    const url = new URL(`${urlGlobal2}/equipos`);
    url.search = new URLSearchParams({ empleadoId: `${empleadoId}` }).toString();
    const resp = await fetch(url, { method: 'GET', headers: getHeaders() });
    return await resp.json();
  } catch (error) {
    return [];
  }
};

export const getPlanesBot = async () => {
  try {
    const resp = await fetch(`${urlGlobal2}/planes`, {
      method: 'GET',
      headers: getHeaders()
    });
    const data = await resp.json();
    if (!Array.isArray(data)) {
      return [];
    }
    return data.filter((plan) => !EXCLUDED_PLAN_IDS.includes(plan.id));
  } catch (error) {
    return [];
  }
};

export const updateEventoBot = async (evento) => {
  try {
    const resp = await fetch(`${urlGlobal2}/eventos`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(evento)
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const addClienteBot = async (cliente) => {
  try {
    const resp = await fetch(`${urlGlobal2}/clientes`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(cliente)
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const addServicioBot = async (servicio) => {
  try {
    const resp = await fetch(`${urlGlobal2}/servicios`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(servicio)
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const addInstalacionBot = async (payload) => {
  try {
    const resp = await fetch(`${urlGlobal2}/instalacion`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(payload)
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const getEmpleadosBot = async () => {
  try {
    const resp = await fetch(`${urlGlobal2}/empleados`, {
      method: 'GET',
      headers: getHeaders()
    });
    const data = await resp.json();
    if (!Array.isArray(data)) return [];
    return data;
  } catch (error) {
    return [];
  }
};

export const getDebtBot = async (clientId) => {
  try {
    const resp = await fetch(`${urlGlobal2}/clientes/getDebt/${clientId}`, {
      method: 'GET',
      headers: getHeaders()
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const entregarEquiposClienteBot = async (equipos, clientId) => {
  try {
    const resp = await fetch(`${urlGlobal2}/equipos/entregarCliente`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ equipos, clientId })
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};

export const addPagoInstaladorBot = async (clientId, amount) => {
  try {
    const resp = await fetch(`${urlGlobal2}/pagos/addPaymentInstalador`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ clientId, amount })
    });
    return await resp.json();
  } catch (error) {
    return { ok: false, mensaje: error.message };
  }
};
